export function videoControls(): void {
    const buttons = document.querySelectorAll<HTMLButtonElement>('button[data-video-controls]');
    const videos = document.querySelectorAll<HTMLVideoElement>('video[autoplay]');

    buttons.forEach(button => {
        button.addEventListener('click', () => {
            // Determine if at least one video is playing
            const isPlaying = Array.from(videos).some(video => !video.paused);

            if (isPlaying) {
                // Pause all videos
                videos.forEach(video => video.pause());
                buttons.forEach(btn => {
                    btn.classList.add('video-paused');
                    btn.classList.remove('video-play');
                });
            } else {
                // Play all videos
                videos.forEach(video => video.play());
                buttons.forEach(btn => {
                    btn.classList.add('video-play');
                    btn.classList.remove('video-paused');
                });
            }
        });
    });
}